import React from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { Square } from "./../Square/Square";
import "./Board.css";
import { calculateWinner } from "./calculateWinner/calculateWinner";

import { playSfx } from "../../functions/clickSfx";
import clickSfx from "../../sfx/click.mp3";

export class Board extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			squares: Array(9).fill(null),
			xTurn: true,
			isMuted: false,
		};
	}
	handleClick(i) {
		const squares = this.state.squares.slice();

		if (calculateWinner(squares) || squares[i]) {
			return;
		}

		squares[i] = this.state.xTurn ? "X" : "O";

		this.setState({ squares: squares, xTurn: !this.state.xTurn });
		if (!this.state.isMuted) playSfx(clickSfx);
	}

	muteClick() {
		this.setState({ isMuted: !this.state.isMuted });
	}

	renderSquare(i) {
		return (
			<Col xs={4}>
				<Square
					id={"square" + i}
					value={this.state.squares[i]}
					onClick={() => this.handleClick(i)}
				/>
			</Col>
		);
	}

	resetGame() {
		this.setState({ squares: Array(9).fill(null), xTurn: true });
	}

	render() {
		const winner = calculateWinner(this.state.squares);
		let status;

		if (winner === "X" || winner === "O") {
			status = "Winner: " + winner;
		} else if (winner === "Draw") {
			status = "Draw!";
		} else {
			status = "Next Player: " + (this.state.xTurn ? "X" : "O");
		}

		return (
			<Container className="board">
				<Row>
					<button
						onClick={() => {
							playSfx(clickSfx);
							this.muteClick();
							
						}}
						className={`mute-button ${
							this.state.isMuted ? "mute-button-on" : ""
						}`}
					>
						Mute
					</button>
					<div className="status">{status}</div>
				</Row>

				<Row>
					{this.renderSquare(0)}
					{this.renderSquare(1)}
					{this.renderSquare(2)}
				</Row>
				<Row>
					{this.renderSquare(3)}
					{this.renderSquare(4)}
					{this.renderSquare(5)}
				</Row>
				<Row>
					{this.renderSquare(6)}
					{this.renderSquare(7)}
					{this.renderSquare(8)}
				</Row>

				{winner ? (
					<button
						className="retryBtn"
						onClick={() => {
							this.resetGame();
							playSfx(clickSfx);
						}}
					>
						Play Again!
					</button>
				) : null}
			</Container>
		);
	}
}
